import { Injectable } from '@angular/core';

@Injectable()
export class AuthService<T> {
  private _token!: T;

  get token() {
    return this._token;
  }

  set token(token: T) {
    this._token = token;
  }

  tokenExpired(token: string) {
    const expiry = JSON.parse(atob(token.split('.')[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }
}
